import type { FormSelectOption } from '@practium/ui';
import type {
	CorrectionSidebarItem,
	CorrectionFormData,
	CalagemFormData,
	FosfatagemFormData,
	GessagemFormData,
	RecommendationTabData,
} from '../types';

export const CORRETIVO_OPTIONS: FormSelectOption[] = [
	{ value: 'calc-dolomitico', label: 'Calcário Dolomítico (CaO: 30, MgO: 16, PRNT: 87)' },
	{ value: 'calc-calcito', label: 'Calcário Calcítico (CaO: 48, MgO: 2, PRNT: 92)' },
	{ value: 'calc-magnesiano', label: 'Calcário Magnesiano (CaO: 38, MgO: 8, PRNT: 85)' },
];

export const FERTILIZANTE_P_OPTIONS: FormSelectOption[] = [
	{ value: 'acido-borico', label: 'Ácido Bórico' },
	{ value: 'superfosfato-simples', label: 'Superfosfato Simples' },
	{ value: 'superfosfato-triplo', label: 'Superfosfato Triplo' },
	{ value: 'fosfato-natural', label: 'Fosfato Natural Reativo' },
];

export const FERTILIZANTE_COMP_OPTIONS: FormSelectOption[] = [
	{ value: 'cloreto-potassio', label: 'Cloreto de Potássio' },
	{ value: 'sulfato-potassio', label: 'Sulfato de Potássio' },
	{ value: 'kcl-50', label: 'KCl 50%' },
];

export const SOIL_ANALYSIS_OPTIONS: FormSelectOption[] = [
	{ value: 'soil-safra-25-26', label: 'Safra_25/26' },
	{ value: 'soil-1', label: 'AgroAnaliza - 2026 - 121' },
	{ value: 'soil-2', label: 'Safra_24/25' },
];

export const CONDICIONADOR_OPTIONS: FormSelectOption[] = [
	{ value: 'gesso-agricola', label: 'Gesso Agrícola' },
	{ value: 'sulfato-calcio', label: 'Sulfato de Cálcio' },
];

export const CORRECTION_TITLES: Record<string, string> = {
	add: 'Nova Recomendação de Correção',
	edit: 'Editar Recomendação de Correção',
	view: 'Informações da Recomendação de Correção',
};

export const CORRECTION_SUBTITLES: Record<string, string> = {
	add: 'Cadastre os dados gerais da nova recomendação',
	edit: 'Edite os dados gerais da recomendação',
	view: 'Visualize os dados gerais da recomendação',
};

export const CORRECTION_SIDEBAR_ITEMS: { key: CorrectionSidebarItem; label: string }[] = [
	{ key: 'general', label: 'Informações Gerais' },
	{ key: 'calagem', label: 'Calagem' },
	{ key: 'fosfatagem', label: 'Fosfatagem' },
	{ key: 'gessagem', label: 'Gessagem' },
	{ key: 'recommendation', label: 'Recomendação' },
	{ key: 'laudo', label: 'Laudo' },
];

export const CALAGEM_METODO_OPTIONS: FormSelectOption[] = [
	{ value: 'satSB', label: 'Saturação por Bases' },
	{ value: 'CaMg', label: 'Neutralização do Al e correção do Ca e Mg' },
];

export const FOSFATAGEM_FORMA_OPTIONS: FormSelectOption[] = [
	{ value: 'sulco', label: 'Sulco' },
	{ value: 'cova', label: 'Cova' },
];

export const APLICACAO_FORMA_OPTIONS: FormSelectOption[] = [
	{ value: 'total', label: 'Área total' },
	{ value: 'sulco', label: 'Sulco' },
	{ value: 'faixa', label: 'Faixa' },
	{ value: 'cova', label: 'Cova' },
];

export const METODO_VALUE_CONFIG: Record<string, { label: string; placeholder: string }> = {
	satSB: { label: 'V desejado (%)*', placeholder: 'Ex.: 70' },
	CaMg: { label: 'Ca + Mg desejado (cmolc/dm³)*', placeholder: 'Ex.: 70' },
};

export const DOSE_SECUNDARIA_LABEL: Record<string, string> = {
	total: '',
	sulco: 'Aplicação no sulco (g/m)',
	faixa: 'Dose na faixa (kg/ha)',
	cova: 'Aplicação na cova (g/cova)',
};

export const DEFAULT_CORRECTION_FORM: CorrectionFormData = {
	name: '',
	prop: '',
	area: '',
	sectors: [],
	soilAnalysis: '',
};

export const DEFAULT_CALAGEM_FORM: CalagemFormData = {
	corretivo: '',
	metodo: '',
	metodoValue: '',
	forma: '',
	profundidade: '',
	largura: '',
	comprimento: '',
};

export const DEFAULT_FOSFATAGEM_FORM: FosfatagemFormData = {
	fertilizanteP: '',
	fertilizanteComplementar: '',
	forma: 'sulco',
	profundidade: '',
	largura: '',
	comprimento: '',
};

export const DEFAULT_GESSAGEM_FORM: GessagemFormData = {
	soilAnalysis: '',
	interpretacao: '',
	condicionador: '',
	satCa2: '40',
	forma: 'total',
	profundidade: '',
	largura: '',
	comprimento: '',
};

export const DEFAULT_RECOMMENDATION_TAB: RecommendationTabData = {
	identificacao: '',
	observacoes: '',
	products: [],
	resultTable: [],
};

export const GESSAGEM_INTERPRETACOES: Record<string, string> = {
	'soil-safra-25-26': 'Al extremamente alto',
	'soil-1': 'Al alto',
	'soil-2': 'Al médio',
};

export const getOptionLabel = (
	options: { value: string; label: string }[],
	value: string
): string => options.find((o) => o.value === value)?.label ?? value ?? '—';
